// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"353":"f978dac4","3508":"0e706984","4941":"df38bc9f"}[chunkId] + ".css";
};